import { countries, isFetchingCountries } from 'home/selectors'
import { connect } from 'react-redux'

import * as actions from './actions'
import FilterCountryModal from './FilterCountryModal'
import * as selectors from './selectors'

const mapStateToProps = state => ({
  countries: countries(state),
  filterCountryInput: selectors.filterCountryInput(state),
  isFetchingCountries: isFetchingCountries(state),
  selectedCountries: selectors.selectedCountries(state),
})

const mapDispatchToProps = {
  setFilterCountryInput: actions.setFilterCountryInput,
  setSelectedCountries: actions.setSelectedCountries,
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterCountryModal)
